import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { getLeadAssignees, bulkAssignLeads } from "@/lib/apiClient";
import { UserCheck, UserX, X } from "lucide-react";
import { toast } from "sonner";

// Floating bar: assign / unassign many selected leads at once, optionally with an instruction note.
export function BulkAssignBar({ selected, onClear, onDone }) {
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { getLeadAssignees().then(setUsers).catch(() => {}); }, []);
  if (!selected.length) return null;

  const run = async (assigned_user_id) => {
    setBusy(true);
    try {
      const r = await bulkAssignLeads({ lead_ids: selected, assigned_user_id, note });
      toast.success(assigned_user_id ? `${r.updated} leads toegewezen` : `Toewijzing weggehaald bij ${r.updated} leads`);
      setNote(""); setUserId(""); onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "Mislukt"); }
    finally { setBusy(false); }
  };

  return createPortal(
    <div className="fixed inset-x-0 bottom-6 z-40 flex justify-center pointer-events-none">
    <div data-testid="bulk-assign-bar" className="pointer-events-auto w-[min(960px,94vw)] rounded-2xl bg-[#001C51] text-white shadow-2xl p-4">
      <div className="flex flex-wrap items-center gap-3">
        <span data-testid="bulk-selected-count" className="font-heading font-semibold">{selected.length} geselecteerd</span>
        <select data-testid="bulk-assign-user" value={userId} onChange={(e) => setUserId(e.target.value)}
          className="rounded-xl bg-white text-[#16202B] text-sm px-3 py-2 min-w-[180px]">
          <option value="">Kies medewerker…</option>
          {users.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
        </select>
        <input data-testid="bulk-assign-note" value={note} onChange={(e) => setNote(e.target.value)} maxLength={4000}
          placeholder="Notitie voor de medewerker (optioneel)"
          className="flex-1 min-w-[200px] rounded-xl bg-white text-[#16202B] text-sm px-3 py-2" />
        <button data-testid="bulk-assign-submit" disabled={busy || !userId} onClick={() => run(userId)}
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-xl bg-[#16BFBF] text-[#001C51] font-medium text-sm hover:bg-[#3fd0d0] disabled:opacity-50">
          <UserCheck className="h-4 w-4" /> Toewijzen
        </button>
        <button data-testid="bulk-unassign" disabled={busy} onClick={() => run("")}
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-xl border border-white/30 text-sm hover:bg-white/10 disabled:opacity-50">
          <UserX className="h-4 w-4" /> Toewijzing weghalen
        </button>
        <button data-testid="bulk-clear" onClick={onClear} title="Selectie wissen" className="p-2 rounded-lg hover:bg-white/10">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
    </div>,
    document.body
  );
}
